if (!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
    }

    calculateHeight() {
      if (!this.opener || !this.body) return;

      this.body.style.setProperty(
        '--height-opened',
        this.body.scrollHeight + 'px'
      );
      this.body.style.setProperty('--height-closed', 0 + 'px');
    }

    connectedCallback() {
      this.opener = this.querySelector('.js-accordion-opener');
      this.body = this.querySelector('.js-accordion-body');

      if (!this.opener || !this.body) return;

      this.calculateHeight();

      window.addEventListener('resize', () => {
        this.calculateHeight();
      });

      this.opener.addEventListener('click', () => {
        this.classList.toggle('is-open');
      });
    }
  }
  customElements.define('accordion-item', AccordionItem);
}
